const form = document.getElementById('CollectionFilterForm');

(() => {
    if (form) {
        const icon = document.createElement('wa-icon');

        icon.setAttribute('name', 'arrow-down');
        icon.setAttribute('class', 'filters-scroll-bottom-arrow');

        // Decide whether to "scroll to bottom" show arrow button initially or not
        // This same height calculation is done to limit the height of the filters (can be found in Theme Settings -> CustomCSS)
        // #CollectionFilterForm {
        //     max-height: calc(100vh - 30px - var(--theme-sticky-header-height));
        //     overflow-y: auto;
        //     overflow-x: hidden;
        // }
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height')) || 0;
        const maxHeight = window.innerHeight - 30 - headerHeight;
        icon.style.opacity = form.scrollHeight > maxHeight ? '1' : '0';

        icon.addEventListener('click', () => {
            form.scrollTo({ top: form.scrollHeight, behavior: 'smooth' });
        })
        form.appendChild(icon);

        form.addEventListener('scroll', () => {
            const isAtBottom = form.scrollTop + form.clientHeight + 32 >= form.scrollHeight;

            icon.style.opacity = isAtBottom ? '0' : '1';
        });
    }
})();
